import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    style: style,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M15.9998 1.02126L14.9785 0L8 6.97855L1.02145 8.49854e-06L0.000188854 1.02127L6.97873 7.99981L0 14.9785L1.02126 15.9998L8 9.02108L14.9787 15.9998L16 14.9786L9.02126 7.99981L15.9998 1.02126Z",
    fill: "white"
  }));
};
export default SVGComponent;